<template>
  <div class="jzliu-bi-engine-mobile-preview">
    <div class="jzliu-bi-engine-mobile-preview-warp">
      <div class="content">
        <slot></slot>
<!--        <div class="mask"></div>-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mobilePreview"
}
</script>

<style scoped lang="less">
.jzliu-bi-engine-mobile-preview {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .jzliu-bi-engine-mobile-preview-warp {
    width: 428px;
    height: 865px;
    position: relative;
    transform: scaleY(0.96);
    background-image: url("../assets/img/dashboard/mobile.png");
    background-repeat: no-repeat;

    .content {
      height: 576px;
      width: 385px;
      position: absolute;
      left: 22px;
      top: 183px;
    }

    .mask {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: transparent;
    }
  }
}
</style>
